<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">老人亲属修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="姓名" required prop="name">
                                    <el-input v-model="editForm.name" placeholder="请输入姓名"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="联系方式" required prop="phone">
                                    <el-input v-model="editForm.phone" placeholder="请输入联系方式"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="关系" required prop="relation">
                                    <el-input v-model="editForm.relation" placeholder="请输入关系"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="是否接收信息" required prop="isReceive">
                                                    <el-radio-group v-model="editForm.isReceive" style="width:100%">
                                                        <el-radio :label="1">是</el-radio>
                                                        <el-radio :label="2">否</el-radio>
                                                    </el-radio-group>
                                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24" class="item">
                                <el-form-item label="是否同住" required prop="isLive">
                                                    <el-radio-group v-model="editForm.isLive" style="width:100%">
                                                        <el-radio :label="1">是</el-radio>
                                                        <el-radio :label="2">否</el-radio>
                                                    </el-radio-group>
                                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24" class="item">
                                <el-form-item label="联系地址" required prop="address">
                                    <el-input v-model="editForm.address" placeholder="请输入联系地址"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Edit',
        data() {
            return {
                loading: false,
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    elderlyRelativesCode:'',
                    name:'',
                    phone:'',
                    relation:'',
                    isReceive:'',
                    isLive:'',
                    address:''
                },
                rules:{
                   name:[
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                    ],
                    phone:[
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                    ],
                    ralation:[
                        { required: true, message: '请输入关系', trigger: 'blur' },
                    ],
                    isReceive:[
                        { required: true, message: '请选择是否接收信息', trigger: 'blur' },
                    ],
                    isLive:[
                        { required: true, message: '请选择是否同住', trigger: 'blur' },
                    ],
                    address:[
                        { required: true, message: '请输入联系地址', trigger: 'blur' },
                    ],
                }

            }
        },
        methods: {
            init(row){
                this.editForm.elderlyRelativesCode = row.elderlyRelativesCode;
                this.editForm.name = row.name;
                this.editForm.phone = row.phone;
                this.editForm.relation = row.relation;
                this.editForm.isReceive = row.isReceive;
                this.editForm.isLive = row.isLive;
                this.editForm.address = row.address;
            },
            closeSelf() {
                this.$emit("closeEdit");
            },
            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })
            },
            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"EElderlyRelatives/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;

                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },

        }
    }


</script>




<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;
            .modal-body /deep/ .el-upload--picture-card{
                width: 100px;
                height: 100px;
                line-height: 100px;
            }
            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
             .modal-body .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
                width:100px;
                height: 100px;
            }
            .modal-body .avatar-uploader .el-upload:hover {
                border-color: #409EFF;
            }
            .modal-body .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 100px;
                height: 100px;
                line-height: 100px;
                text-align: center;
            }
            .modal-body .avatar {
                width: 100%;
                height: 100%;
                border-radius: 6px;
                display: block;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }
            .uploadButton{
                border-top: 1px solid #eee;
                padding: 10px 0 0;
                display: flex;
                 .el-button{
                    width: 100px;
                }
            }

        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
